import { Typography } from '@mui/material';

import { CreditTerms } from '../../../../domain/qualification';

type Props = {
  billingCycle?: CreditTerms['billingCycle'];
  gracePeriodDays?: CreditTerms['gracePeriodDays'];
};

const calculateBillingPeriod = (billingCycle?: number) => {
  switch (billingCycle) {
    case 7:
      return 'week';
    case 14:
      return 'two weeks';
    case 30:
    default:
      return 'month';
  }
};

const CreditTermsText = ({ billingCycle, gracePeriodDays }: Props) => {
  const billingPeriod = calculateBillingPeriod(billingCycle);

  return (
    <Typography variant="body2" align="center" color="textSecondary">
      If you&apos;re approved, your statement will be generated every{' '}
      <Typography variant="subtitle2-semibold" component="span" color="textSecondary">
        {billingPeriod}
      </Typography>{' '}
      and must be paid in full within{' '}
      <Typography variant="subtitle2-semibold" component="span" color="textSecondary">
        {gracePeriodDays ?? 10}
      </Typography>{' '}
      days of your statement end date.
    </Typography>
  );
};

export { CreditTermsText };
